<template>
  <div id="loot-box-management">
    <info-box v-bind:description="description"></info-box>
    <header-title title="LOOT BOXES" />
    <span v-if="notification">{{notification}}</span> 
    <div>
      <button class="btn-enabled" @click="create()">CREATE</button>
      <div>{{lootBoxPageCurrent}}</div>
      <table class="editor-table" v-if="lootBoxPages[lootBoxPageCurrent]"> 
        <tr v-for="item in lootBoxPages[lootBoxPageCurrent]['loot_items']" v-bind:key="item.id">
          <td><img :src="lootItemImageUrl(item)" style="width:100px;"/></td>
          <td>{{item.name}}</td>
          <td><router-link class="btn-enabled" style="width: 50px; height: 30px; line-height: 30px;text-align:center;" :to="{ name: 'LootBoxEditor', params: { itemId: item.id }}">Edit</router-link></td>
        </tr>
      </table>
      <button v-if="lootBoxPages.length > 18" class="btn-enabled" @click="next()">Next</button>
      <button v-if="lootBoxPageCurrent > 0" class="btn-enabled" @click="back()">Back</button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Vue from 'vue'
// import BigNumber from 'BigNumber.js'
// import axios from 'axios'
import router from '../router'

export default {
  name: 'loot-box-management',
  components: {
  },
  async mounted () {
    await this.refreshLootBoxes()
  },
  data () {
    return {
      description: {
        title: 'Loot Box Management',
        text: `Do it!`
      },
      notification: undefined
    }
  },
  computed: Object.assign(mapState(['currentUser', 'lootShopLootItemIds', 'lootShopLootItems', 'lootBoxPageCurrent', 'lootBoxPages']), {
  }),
  methods: {
    next () {
      if (this.lootBoxPages.length - 1 > this.lootBoxPageCurrent) {
        this.$store.dispatch('gotoLootBoxPage', this.lootBoxPageCurrent + 1)
      } else {
        this.$store.dispatch('fetchLootBoxPage', this.lootBoxPages[this.lootBoxPageCurrent].cursor)
      }
    },
    back () {
      this.$store.dispatch('gotoLootBoxPage', this.lootBoxPageCurrent - 1)
    },
    async refreshLootBoxes () {
      await this.$store.dispatch('lootBoxPageReset')
      this.$store.dispatch('fetchLootBoxPage')
    },
    categoryTextFor (shopItem) {
      if (shopItem.category === 'lootChest') {
        return 'Virtual LOOTCHEST'
      } else if (shopItem.category === 'roomItem') {
        return 'Virtual Room Item'
      } else {
        return 'Token'
      }
    },
    lootShopLootItemForId (id) {
      return this.$store.state.lootShopLootItems[id]
    },
    lootItemImageUrl (lootItem) {
      return `${Vue.config.WEB_ASSET_BASE_URL}/${lootItem.image_url}`
    },
    currencyIcon (priceCurrencyType) {
      let image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png'

      return `${Vue.config.WEB_ASSET_BASE_URL}/${image}`
    },
    attributionText (lootItem) {
      if (!lootItem.attribution_author) { return }
      // // "Creative Commons 10th Birthday Celebration San Francisco" by tvol is licensed under CC BY 2.0
      return `<a href="${lootItem.attribution_title_url}" target="_blank">"${lootItem.attribution_title}"</a> by <a href="${lootItem.attribution_author_url}" target="_blank">${lootItem.attribution_author}</a> <br/> Licensed under <a href="${lootItem.attribution_license_url}" target="_blank">${lootItem.attribution_license}</a>`
    },
    requiresAttribution (lootItem) {
      return !!lootItem.attribution_author
    },
    notify (text) {
      this.notification = text
      setTimeout(() => {
        this.notification = undefined
      }, 5000)
    },
    create () {
      router.push({ name: 'LootBoxEditorCreate' })
    }
  },
  watch: {
  }
}
</script>

<style scoped>
  .rarity-common {
    color: rgb(255, 255, 255);
  }

  .rarity-uncommon {
    color: rgb(17, 116, 14);
  }

  .rarity-rare {
    color: rgb(51, 81, 212);
  }

  .rarity-legendary {
    color: rgb(190, 34, 204);
  }

  .rarity-exotic {
    color: rgb(228, 197, 21);
  }
  .shop-image {
    max-width: 200px;
    max-height:200px;
  }

  .shop-item {
    width: 200px;
  }

  .currency-icon {
    max-width:20px;
    padding-left: 5px;
  }

  .price-content {
    display: flex; 
    align-items: center;  
    justify-content: center;
  }

  .btn-enabled{
    width:100%;
    display: inline-block;
    border-top: 4px var(--sl-red) solid;
    padding: 5px;
    border-radius: 4px;
    box-shadow: 0px 3px 3px 3px rgba(0, 0, 0, 0.4);
    transition: background-color 0.2s , border-color 0.2s;
    margin: 5px;
    min-width: 50px;
    user-select: none;
    color:white;

    background-color: #5A3E85;
    height: 40px;
    margin-top: 5px;
    border-radius: 5px;
    border-top: 2px rgb(126, 85, 187) solid;
    padding: 0px 10px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.btn-enabled:hover{
    background-color: var(--sl-red);
    border-top: 4px rgb(255, 0, 0) solid;
}
.btn-selected{
  background-color: var(--sl-red);
    border-top: 4px rgb(255, 0, 0) solid;
}

tr:nth-child(even){
  background-color:#5a5a61;
}
tr:nth-child(odd){
  background-color:#484444;
}

.editor-table {
  width:100%;
  border:1px solid white;
  text-align:left;
}

</style><style>
a {
  text-decoration: none;
  color: #445278;
}

a:visited {
  color: #4d566e;
}

a:hover {
  color: #62729c;
}

</style>


// WEBPACK FOOTER //
// src/components/Loot-Box-Management.vue